<template>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
        <v-row>
            <v-col cols="12" sm="12">
                <v-card class="pa-3 rounded-0 elevation-0 mt-6" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                    <v-sheet class="transactionTable liveTradeTable pb-3"
                        :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                        <v-data-table :headers="headers" :items="investorTradingAccountTradehistory"
                            :items-per-page="6">
                            <template v-slot:item.Action="{ item }">
                                <span class="profit-text-color">
                                    {{
                                        item?.Action === 0
                                            ? "Buy"
                                            : item?.Action === 1
                                                ? "Sell"
                                                : null
                                    }}
                                </span>
                            </template>
                            <template v-slot:item.Volume="{ item }">
                                {{ item?.Volume / 10000 }}
                            </template>
                            <template v-slot:item.Time="{ item }">
                                {{ formatMySQLDate(item?.Time) }}
                            </template>
                            <template v-slot:item.PriceOpen="{ item }">
                                {{ item?.PriceOpen?.toFixed(5) }}
                            </template>
                            <template v-slot:item.PriceSL="{ item }">
                                {{ item?.PriceSL?.toFixed(2) }} -
                                {{ item?.PriceTP?.toFixed(2) }}
                            </template>
                        </v-data-table>
                    </v-sheet>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            headers: [
                { text: "Ticket", value: "PositionID", align: "start" },
                {
                    text: "Date & Time",
                    value: "Time",
                },
                { text: "Type", value: "Action" },
                { text: "Lots", value: "Volume" },
                { text: "Symbol", value: "Symbol" },
                { text: "Open price", value: "PricePosition" },
                { text: "SL-TP", value: "PriceSL" },
                { text: "Closed Price", value: "Price" },
                { text: "Profit", value: "Profit" },
            ],
        };
    },

    computed: {
        ...mapState("trading", ["investorTradingAccountTradehistory"]),
    },

    methods: {
        ...mapActions("trading", [
            TRADING__ACTIONS.INVESTORACCOUNTTRADEHISTORY,
        ]),
         formatMySQLDate(mysqlDate) {
    

    // Ensure the input is in the correct format
    if (!mysqlDate) return "Invalid date";

    // Replace the "T" with a space to work with the current logic
    const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
    const [datePart, timePart] = isoFormattedDate.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    // Convert 24-hour time to 12-hour time
    const hour12 = hour % 12 || 12;
    const amPm = hour >= 12 ? 'pm' : 'am';

    // Return the formatted date and time
    return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
},
    },

    async mounted() {
        await this[TRADING__ACTIONS.INVESTORACCOUNTTRADEHISTORY](
            this.$route.query.id
        );
    },
};
</script>
